<template>
  <div id="_user_profile_frame" v-if="userProfile" class="q-mt-xl">
    <div class="row justify-center">
      <q-avatar color="primary" class="text-white">
        {{ (userProfile.nickname || "").substr(0, 1) }}
      </q-avatar>
    </div>
    <div
      class="full-width text-center text-bold q-py-md"
      style="font-size: 1.4rem"
    >
      {{ userProfile.nickname }}
    </div>

    <div class="full-width text-center">
      {{ userProfile.phone_number }}
    </div>

    <div class="row justify-center q-mt-lg">
      <q-btn outline color="primary" @click="logout">
        登出
      </q-btn>
    </div>

    <div class="row items-center justify-center q-mt-md">
      <router-link
        v-for="role in userProfile.roles.filter(
          (role) => role.value != '005'
        ) || []"
        :key="role.id"
        :to="{
          name: {
            '001': 'admin_page',
            '002': 'leader_page',
            '003': 'member_page',
            '004': 'telep_intv',
          }[role.value],
        }"
      >
        <q-btn outline color="primary" class="q-px-sm q-pb-sm">
          前往 {{ role.description }} 主页
        </q-btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import AuthMixin from "./auth.mixin";
import { logout } from "../../api/endpoints/auth/logout";
export default {
  mixins: [AuthMixin],

  data() {
    return {
      userProfile: null,
    };
  },

  mounted() {
    this.getUserProfile(true).then((profile) => (this.userProfile = profile));
  },

  methods: {
    async logout() {
      await logout();
      this.resolveUserStatus();
    },
  },
};
</script>
